var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarPlayAndroidAudio24 = function SvgCarPlayAndroidAudio24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.087 3H5.914C3.752 3 2 4.691 2 6.777v10.446C2 19.309 3.752 21 5.914 21h12.173C20.247 21 22 19.309 22 17.223V6.777C22 4.691 20.248 3 18.087 3Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10.207v3.586a.24.24 0 0 0 .024.103.197.197 0 0 0 .063.075.158.158 0 0 0 .086.029c.03 0 .06-.008.088-.025l2.65-1.797a.196.196 0 0 0 .065-.077.24.24 0 0 0 0-.21.196.196 0 0 0-.065-.078l-2.65-1.788a.156.156 0 0 0-.088-.025.14.14 0 0 0-.086.03.197.197 0 0 0-.063.075.24.24 0 0 0-.024.102Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM2.015 8c.852.22 1.61.733 2.152 1.46.541.726.835 1.623.833 2.546a4.251 4.251 0 0 1-.843 2.543A3.9 3.9 0 0 1 2 16m20 0a3.897 3.897 0 0 1-2.157-1.45A4.253 4.253 0 0 1 19 12.007a4.254 4.254 0 0 1 .832-2.547A3.9 3.9 0 0 1 21.982 8",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })));
};
export default SvgCarPlayAndroidAudio24;